import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth-store'
export function RequireUser() {
  const phone = useAuthStore((state) => state.userPhone)
  const hydrated = useAuthStore((state) => state.hydrated)
  const location = useLocation()
  if (!hydrated)
    return <main className="grid min-h-[40vh] place-items-center">正在验证登录状态…</main>
  return phone ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: `${location.pathname}${location.search}` }} replace />
  )
}
